var _path, _path2, _path3;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPressureVessel = function SvgPressureVessel(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 25V49H4V46H6.75463C8.22075 47.8289 10.4736 49 13 49H14V55H2V57H14H22H58H66L78 57V55H66V49H70C74.4183 49 78 45.4183 78 41V33C78 28.5817 74.4183 25 70 25H13C10.4736 25 8.22075 26.1711 6.75463 28H4V25H2ZM64 55V49H60V55H64ZM58 55V49H22V55L58 55ZM20 55V49H16V55H20ZM66 47H58H22H14H13C9.68629 47 7 44.3137 7 41V33C7 29.6863 9.68629 27 13 27H70C73.3137 27 76 29.6863 76 33V41C76 44.3137 73.3137 47 70 47H66ZM5.58152 44H4L4 30H5.58152C5.20651 30.9264 5 31.9391 5 33V41C5 42.0609 5.20651 43.0736 5.58152 44Z",
    fill: "#4281AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 23C61 22.4477 61.4477 22 62 22L67 22C67.5523 22 68 22.4477 68 23C68 23.5523 67.5523 24 67 24L62 24C61.4477 24 61 23.5523 61 23Z",
    fill: "#4281AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 23C35 22.4477 35.4477 22 36 22L44 22C44.5523 22 45 22.4477 45 23C45 23.5523 44.5523 24 44 24L36 24C35.4477 24 35 23.5523 35 23Z",
    fill: "#4281AF"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPressureVessel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pressureVessel.88d3a892.svg";
export { ForwardRef as ReactComponent };